import { common, economic, input } from "../../../../../i18n";
import { useTranslation } from "react-i18next";
import {
  GridColDef,
  GridColumnGroupingModel,
} from "@mui/x-data-grid";
import { tableStyle } from "../../../../emission/_components/data-table/EmissionDataTableStyle";
import { Box } from "@mui/material";
import { AppDataGrid } from "../../../../../components/datagrid/AppDataGrid";

interface Props {
  rows: any[];
  columns: GridColDef<any>[];
  columnGroupingModel?: GridColumnGroupingModel;
  hideFooter?: boolean;
}

export const EcoEfficiencyTable = ({
  rows,
  columns,
  columnGroupingModel,
  hideFooter = true,
}: Props) => {
  const { t } = useTranslation([common, input, economic], {
    nsMode: "fallback",
  });

  const paginationProps = hideFooter
    ? {}
    : {
        initialState: {
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        },
        pageSizeOptions: [10, 20, 30],
      };

  return (
    <Box minHeight={"290px"}>
      <AppDataGrid
        rows={rows}
        columns={columns}
        columnGroupingModel={columnGroupingModel}
        rowHeight={60}
        sx={{
          ...tableStyle(),
        }}
        disableMultipleRowSelection={true}
        hideFooter={hideFooter}
        autoHeight
        localeText={{
          noRowsLabel: `${t("No-Data")}`,
        }}
        {...paginationProps}
      />
    </Box>
  );
};
